<script setup lang="ts">
  import zhCN from "ant-design-vue/es/locale/zh_CN";
  import { computed, onMounted } from "vue";
  import { useRoute } from "vue-router";
  import PageFooterNew from "~/components/layouts/PageFooterNew.vue";
  import PageHeaderNew from "~/components/layouts/PageHeaderNew.vue";
  import PageTools from "~/components/tools/PageTools.vue";
  import "./nav-layout.less";

  const route = useRoute();
  const locale = zhCN;

  const layoutClass = computed((): string => {
    const path = route.path.replace("/", "");
    return `nav-layout-path-${path}`;
  });

  const pageKey = computed((): string => route.fullPath);

  onMounted((): void => {
    document.body.classList.remove("h5-layout-body");
  });
</script>

<template>
  <a-config-provider :locale="locale">
    <div class="nav-layout" :class="layoutClass">
      <PageHeaderNew />
      <NuxtPage :key="pageKey" />
      <PageTools />
      <PageFooterNew />
    </div>
  </a-config-provider>
</template>
